"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const icons_1 = require("../../icons");
const breadCrumbs_styles_1 = __importDefault(require("./breadCrumbs.styles"));
const BreadCrumbs = ({ classes, items = [], separatorIcon = 'ArrowSimpleRight' }) => !items.length ? null : (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root }, { children: items.map((item, idx) => {
        const { label, icon, onClick } = item;
        if (!icon && !label)
            return null;
        return (jsx_runtime_1.jsxs(react_1.Fragment, { children: [idx > 0 && jsx_runtime_1.jsx(icons_1.Icon, { name: separatorIcon, size: 18 }, void 0),
                jsx_runtime_1.jsxs("button", Object.assign({ className: classes.item, onClick: onClick, "data-is-last": idx === items.length - 1, disabled: !onClick }, { children: [icon && jsx_runtime_1.jsx(icons_1.Icon, { name: icon, size: 18 }, void 0), label] }), void 0)] }, idx));
    }) }), void 0));
exports.BreadCrumbs = BreadCrumbs;
exports.default = react_jss_1.default(breadCrumbs_styles_1.default)(react_1.memo(exports.BreadCrumbs));
//# sourceMappingURL=index.js.map